import Vue from 'vue';
import App from './App.vue';
import router from './router'
import store from './data/store';
import BootstrapVue from 'bootstrap-vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTrashAlt, faInfo, faAlignJustify, faPlus, faCloudUploadAlt, faLaptop, faSpinner, faPlay, faStop, faExchangeAlt, faDownload, faAngleRight, faSmile, faPenSquare, faExclamationCircle, faSync } from '@fortawesome/free-solid-svg-icons';
import { faWindows, faUbuntu } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueAppInsights from 'vue-application-insights';

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/site.less'

library.add(faSync);
library.add(faTrashAlt);
library.add(faInfo);
library.add(faAlignJustify);
library.add(faPlus);
library.add(faCloudUploadAlt);
library.add(faLaptop);
library.add(faSpinner);
library.add(faPlay);
library.add(faStop);
library.add(faExchangeAlt);
library.add(faDownload);
library.add(faAngleRight);
library.add(faSmile);
library.add(faPenSquare);
library.add(faExclamationCircle);
library.add(faWindows);
library.add(faUbuntu);

Vue.use(BootstrapVue);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(VueSweetalert2);


Vue.config.productionTip = false;

var redirectUri = process.env.VUE_APP_REDIRECT_URI
if(window.location.host.includes("preview")){
  redirectUri = process.env.VUE_APP_REDIRECT_URI.replace("-api", "-portal").replace("/api/", "");
}

Vue.use(VueAppInsights, {
  id: process.env.VUE_APP_INSTRUMENTATION_KEY,
  enableAutoRouteTracking: true,
  router
})

new Vue({
  store,
  beforeCreate() {
		this.$store.dispatch('initializeStore');
	},
  router,
  render: (h: any) => h(App),
}).$mount('#app');
